// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_dict from "../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../node_modules/rescript/lib/es6/js_json.js";
import * as Js_math from "../../../node_modules/rescript/lib/es6/js_math.js";
import * as Rollbar from "../../../node_modules/rescript-rollbar/lib/es6_global/src/Rollbar.bs.js";
import * as Caml_obj from "../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../node_modules/rescript/lib/es6/caml_option.js";
import * as JsUtils$Showside from "./utils/JsUtils.bs.js";
import * as Optimize$ApiTypes from "../../../node_modules/api-types/lib/es6_global/src/Optimize.bs.js";
import * as AltFunnel$Showside from "./utils/AltFunnel.bs.js";
import * as Caml_js_exceptions from "../../../node_modules/rescript/lib/es6/caml_js_exceptions.js";
import * as OptimizeLog$Showside from "./utils/OptimizeLog.bs.js";
import * as LocalStorage$Showside from "./utils/LocalStorage.bs.js";
import * as OptimizeData$Showside from "./utils/OptimizeData.bs.js";
import * as OptimizeFacts$Showside from "./utils/OptimizeFacts.bs.js";
import * as FirebaseConfig$Showside from "./utils/FirebaseConfig.bs.js";
import * as RollbarInstance$Showside from "./utils/RollbarInstance.bs.js";
import * as ShopifyAnalytics$Showside from "./utils/ShopifyAnalytics.bs.js";
import * as OptimizeEngineRunner$Showside from "./utils/OptimizeEngineRunner.bs.js";
import * as UserSavedProductsTypes$Showside from "./types/UserSavedProductsTypes.bs.js";
var ourMeasurementId = FirebaseConfig$Showside.config.measurementId;
function getPreview(param) {
  var url = new URL(window.location.href);
  var experimentId = url.searchParams.get("maker_preview_experiment");
  var variantId = url.searchParams.get("maker_preview_variant");
  if (!(experimentId == null) && !(variantId == null)) {
    return [experimentId, variantId];
  }
}
function getIgnore(param) {
  try {
    return Caml_obj.equal(Caml_option.nullable_to_opt(new URL(window.location.href).searchParams.get("maker_ignore_optimize")), "true");
  } catch (exn) {
    return false;
  }
}
var checkRawJs = function (script) {
  try {
    return Boolean(new Function(script)());
  } catch (e) {
    return false;
  }
};
function getPreviousEvents(param) {
  var value = LocalStorage$Showside.get(undefined, "optimizePreviousEvents");
  if (value === undefined) {
    return [];
  }
  try {
    var parsed = JSON.parse(value);
    return Belt_Array.keepMap(Belt_Option.getWithDefault(Js_json.decodeArray(parsed), [parsed]), Js_json.decodeObject);
  } catch (exn) {
    return [];
  }
}
var sendEventToGA = function sendEventToGA(eventData) {
  // Fire the event in GA4 on the variant page
  if (window.gtag) {
    window.gtag('event', 'experience_impression', eventData);

    // Send the same event to our GA measurement ID
    window.gtag('event', 'experience_impression', {
      ...eventData,
      send_to: ourMeasurementId
    });
    return;
  }
  if (window.dataLayer) {
    window.dataLayer.push({
      event: 'experience_impression',
      ...eventData
    });

    // Send the same event to our GA measurement ID
    window.dataLayer.push({
      ...eventData,
      event: 'experience_impression',
      send_to: ourMeasurementId
    });
  }
};
function fireEvent(retryOpt, measurementId, expId, varId, clientId) {
  var retry = retryOpt !== undefined ? retryOpt : 0;
  var eventData = Js_dict.fromArray([["exp_variant_string", "mkr-" + expId + "-" + varId], ["event_category", "experiment"], ["experiment_id", expId], ["variant_id", varId], ["mkr_exp_client_id", clientId], ["non_interaction", true]]);
  if (measurementId !== undefined) {
    eventData["send_to"] = measurementId;
  }
  var previousData = getPreviousEvents(undefined);
  LocalStorage$Showside.set(undefined, "optimizePreviousEvents", Belt_Option.getWithDefault(JSON.stringify(Belt_Array.concat(previousData, [eventData])), "[]"));
  var match = window.gtag;
  if (match !== undefined || retry >= 70) {
    return sendEventToGA(eventData);
  } else {
    setTimeout(function (param) {
      fireEvent(retry + 1 | 0, measurementId, expId, varId, clientId);
    }, 42);
    return;
  }
}
function fireEventsAgain(retryOpt, previousEvents, log) {
  var retry = retryOpt !== undefined ? retryOpt : 0;
  var match = window.gtag;
  if (previousEvents.length === 0) {
    return;
  }
  if (match === undefined && retry < 70) {
    setTimeout(function (param) {
      fireEventsAgain(retry + 1 | 0, previousEvents, log);
    }, 42);
    return;
  }
  Belt_Array.forEach(previousEvents, function (eventData) {
    Curry._2(log, "fire GA event from previous page", eventData);
    sendEventToGA(eventData);
  });
  LocalStorage$Showside.$$delete(undefined, "optimizePreviousEvents");
}
function getRememberedVariant(experiment) {
  var match = experiment.experimentType;
  var match$1 = experiment.rememberVisitor;
  if (match !== 1) {
    return;
  }
  if (!match$1) {
    return;
  }
  var name = OptimizeFacts$Showside.getRememberVisitorCookieName(experiment);
  return Belt_Option.flatMap(Js_dict.get(OptimizeFacts$Showside.getCookies(undefined), name), function (value) {
    var value$1 = Js_json.decodeString(value);
    if (value$1 === "") {
      return;
    } else {
      return value$1;
    }
  });
}
function getNormalisedWeigth(wghtVal, coverage, allWeights) {
  return wghtVal * coverage / allWeights;
}
function floatFromClientId(clientId) {
  return Belt_Option.getWithDefault(Belt_Float.fromString(clientId), 0.0) / 4294967296;
}
function getVariantIndex(variantRanges, clientId, coverage) {
  var allWeights = Belt_Array.reduce(variantRanges, 0, function (acc, val) {
    return acc + val | 0;
  });
  var targetValue = floatFromClientId(clientId) * allWeights;
  var cumulativeWeight = {
    contents: 0.0
  };
  OptimizeLog$Showside.log2("targetValue", targetValue);
  return Belt_Array.getIndexBy(variantRanges, function (variant) {
    cumulativeWeight.contents = cumulativeWeight.contents + getNormalisedWeigth(variant, coverage, allWeights);
    return targetValue < cumulativeWeight.contents;
  });
}
function getVariant(variants, clientId, coverage) {
  var index = getVariantIndex(Belt_Array.map(variants, function (v) {
    return v.splitRange;
  }), clientId, coverage);
  if (index !== undefined) {
    return Belt_Array.get(variants, index);
  }
}
async function reportToRollbar(message, exn) {
  var error = Rollbar.$$Error.fromRescript(JsUtils$Showside.Exn.unwrapJsError(exn));
  var rootCause = Rollbar.$$Error.getRootCause(error);
  var match = rootCause.message;
  var match$1 = rootCause.name;
  var rootCauseMessage = match !== undefined ? match$1 !== undefined ? "RC: " + match$1 + " " + match + "" : "RC: " + match + "" : match$1 !== undefined ? "RC: " + match$1 + "" : undefined;
  var message$1 = Belt_Array.keepMap([message, rootCauseMessage], function (a) {
    return a;
  }).join(", ");
  return await RollbarInstance$Showside.jsError2(Rollbar.$$Error.fromStringWithCause(message$1, rootCause), message$1);
}
var generateRandom32Bit = function generateRandom32Bit() {
  let array = new Uint32Array(1);
  crypto.getRandomValues(array);
  return array[0];
};
function getClientId(experimentOrGroupId) {
  var clientId = LocalStorage$Showside.get(undefined, {
    NAME: "clientId",
    VAL: experimentOrGroupId
  });
  var exit = 0;
  if (clientId !== undefined) {
    if (clientId.includes(".") === false) {
      OptimizeLog$Showside.log2("use existing client id", clientId);
      return clientId;
    }
    exit = 1;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    var legacyClientId = LocalStorage$Showside.get(undefined, "legacyClientId");
    var clientId$1;
    var exit$1 = 0;
    if (legacyClientId !== undefined && legacyClientId.includes(".") === false) {
      clientId$1 = legacyClientId;
    } else {
      exit$1 = 2;
    }
    if (exit$1 === 2) {
      var tmp;
      try {
        tmp = generateRandom32Bit();
      } catch (raw_e) {
        var e = Caml_js_exceptions.internalToOCamlException(raw_e);
        reportToRollbar("Failed to generate random 32 bit integer, falling back to Math.random", e);
        tmp = Js_math.floor_int(Math.random() * 1e10);
      }
      clientId$1 = String(tmp);
    }
    OptimizeLog$Showside.log2("generated new client id", clientId$1);
    LocalStorage$Showside.set(undefined, {
      NAME: "clientId",
      VAL: experimentOrGroupId
    }, clientId$1);
    return clientId$1;
  }
}
function findMatchingGroup(groups) {
  var previouslySelectedGroupId = LocalStorage$Showside.get(undefined, {
    NAME: "optimizeVariant",
    VAL: "group"
  });
  var previousGroup = previouslySelectedGroupId !== undefined ? Belt_Array.getBy(groups, function (g) {
    return Curry._1(Optimize$ApiTypes.Group.Id.toString, g.id) === previouslySelectedGroupId;
  }) : undefined;
  if (groups.length !== 0) {
    if (previouslySelectedGroupId !== undefined) {
      if (previousGroup !== undefined) {
        OptimizeLog$Showside.log2("previously selected group", previouslySelectedGroupId);
        OptimizeLog$Showside.logWinner(undefined, "group", previouslySelectedGroupId);
        return previousGroup;
      }
      if (previouslySelectedGroupId === "independent") {
        OptimizeLog$Showside.log2("previously selected group", "independent");
        OptimizeLog$Showside.logWinner(undefined, "group", "independent");
        return previousGroup;
      }
    }
  } else {
    OptimizeLog$Showside.log2("no groups found", groups);
    return;
  }
  var clientId = getClientId("group");
  var variantRanges = Belt_Array.map(groups, function (group) {
    return group.coverage;
  });
  var coverage = Belt_Array.reduce(variantRanges, 0, function (a, b) {
    return a + b | 0;
  });
  var independentRange = Math.max(0, 100 - coverage | 0);
  var variantRanges$1 = Belt_Array.concat(variantRanges, [independentRange]);
  var coverage$1 = coverage + independentRange | 0;
  var index = getVariantIndex(variantRanges$1, clientId, coverage$1);
  var result = index !== undefined ? Belt_Array.get(groups, index) : undefined;
  var groupId = Belt_Option.mapWithDefault(result, "independent", function (g) {
    return Curry._1(Optimize$ApiTypes.Group.Id.toString, g.id);
  });
  if (result !== undefined) {
    OptimizeLog$Showside.log2("selected group", result);
  } else {
    OptimizeLog$Showside.log2("selected independent group", result);
  }
  OptimizeLog$Showside.logWinner(undefined, "group", groupId);
  LocalStorage$Showside.set(undefined, {
    NAME: "optimizeVariant",
    VAL: "group"
  }, groupId);
  return result;
}
async function matchPageTargeting(ruleFilterOpt, experiment, facts) {
  var ruleFilter = ruleFilterOpt !== undefined ? ruleFilterOpt : function (rule) {
    return rule;
  };
  var pageTargetRule = Curry._1(ruleFilter, experiment.pageTargetRule);
  var data = await OptimizeEngineRunner$Showside.execute(pageTargetRule, facts);
  OptimizeLog$Showside.logResults(experiment.id, true, Belt_Array.concat(data.failureResults, data.results));
  return data.events.length > 0;
}
function isCustomJsRule(rule) {
  return rule.fact === "Custom JS";
}
async function matchAudienceTargeting(experiment, facts) {
  var audienceTargetRule = experiment.audienceTargetRule;
  var conditions = audienceTargetRule.conditions.all;
  var conditions$1 = audienceTargetRule.conditions.any;
  var data = await OptimizeEngineRunner$Showside.execute({
    conditions: {
      all: conditions !== undefined ? Belt_Array.keep(conditions, function (rule) {
        return rule.fact === "Custom JS" === false;
      }) : undefined,
      any: conditions$1 !== undefined ? Belt_Array.keep(conditions$1, function (rule) {
        return rule.fact === "Custom JS" === false;
      }) : undefined
    },
    event: audienceTargetRule.event
  }, facts);
  OptimizeLog$Showside.logResults(experiment.id, undefined, data.failureResults);
  OptimizeLog$Showside.logResults(experiment.id, undefined, data.results);
  return data.events.length > 0;
}
function validateCustomJsRules(rules, experiment, condition) {
  return Belt_Array.reduce(rules, true, function (acc, rule) {
    var result = checkRawJs(Belt_Option.getWithDefault(Js_json.decodeString(rule.value), ""));
    var fact_name = rule.name;
    var fact_fact = rule.fact;
    var fact_operator = rule.operator;
    var fact_value = rule.value;
    var fact_path = rule.path;
    var fact = {
      name: fact_name,
      fact: fact_fact,
      operator: fact_operator,
      value: fact_value,
      path: fact_path,
      result: result
    };
    OptimizeLog$Showside.logResults(experiment.id, undefined, [{
      conditions: {
        all: condition === "all" ? [fact] : undefined,
        any: condition === "any" ? [fact] : undefined
      }
    }]);
    if (condition === "any") {
      if (acc) {
        return true;
      } else {
        return result;
      }
    } else if (acc) {
      return result;
    } else {
      return false;
    }
  });
}
async function matchCustomJs(experiment) {
  var all = validateCustomJsRules(Belt_Array.keep(Belt_Option.getWithDefault(experiment.audienceTargetRule.conditions.all, []), isCustomJsRule), experiment, "all");
  var any = validateCustomJsRules(Belt_Array.keep(Belt_Option.getWithDefault(experiment.audienceTargetRule.conditions.any, []), isCustomJsRule), experiment, "any");
  if (all) {
    return any;
  } else {
    return false;
  }
}
function removeRulesForRememberedVariant(experiment) {
  var removeNonEssentialRules = function (rules) {
    return Belt_Array.keep(rules, function (rule) {
      var match = rule.fact;
      switch (match) {
        case "Host":
        case "Nav Type":
        case "Path":
          return true;
        default:
          return false;
      }
    });
  };
  var newrecord = Caml_obj.obj_dup(experiment);
  var init = experiment.audienceTargetRule;
  newrecord.audienceTargetRule = {
    conditions: {
      all: Belt_Option.map(experiment.audienceTargetRule.conditions.all, function (param) {
        return [];
      }),
      any: Belt_Option.map(experiment.audienceTargetRule.conditions.any, function (param) {
        return [];
      })
    },
    event: init.event
  };
  var init$1 = experiment.pageTargetRule;
  newrecord.pageTargetRule = {
    conditions: {
      all: Belt_Option.map(experiment.pageTargetRule.conditions.all, removeNonEssentialRules),
      any: Belt_Option.map(experiment.pageTargetRule.conditions.any, removeNonEssentialRules)
    },
    event: init$1.event
  };
  return newrecord;
}
async function isExperimentMatching(experiment, facts) {
  var rememberedVariant = getRememberedVariant(experiment);
  var experiment$1 = rememberedVariant !== undefined ? removeRulesForRememberedVariant(experiment) : experiment;
  var matching = await matchPageTargeting(undefined, experiment$1, facts);
  var matching$1 = matching && (await matchAudienceTargeting(experiment$1, facts));
  var matching$2 = matching$1 && (await matchCustomJs(experiment$1));
  if (matching$2 && rememberedVariant !== undefined) {
    OptimizeLog$Showside.log("remembered experiment matched");
  }
  return matching$2;
}
async function findMatchingExperiment(experiments, facts) {
  var experiments$1 = Belt_Array.keep(experiments, function (experiment) {
    if (experiment.status === /* Active */1 && Caml_obj.lessthan(experiment.experimentStartAt, Date.now())) {
      return Caml_obj.greaterthan(experiment.experimentEndAt, Date.now());
    } else {
      return false;
    }
  });
  var matchExperiment = async function (experiments) {
    var experiment = Belt_Array.get(experiments, 0);
    if (experiment === undefined) {
      return;
    }
    var matching = await isExperimentMatching(experiment, facts);
    if (matching) {
      return experiment;
    } else {
      return await matchExperiment(Belt_Array.slice(experiments, 1, experiments.length));
    }
  };
  return await matchExperiment(experiments$1);
}
async function matchVariant(previewVariantId, clientId, experiment) {
  var rememberedVariant = getRememberedVariant(experiment);
  var experimentOrGroupId = Belt_Option.mapWithDefault(experiment.groupId, experiment.id, Optimize$ApiTypes.Group.Id.toString);
  var previouslySelectedVariant = LocalStorage$Showside.get(undefined, {
    NAME: "optimizeVariant",
    VAL: experimentOrGroupId
  });
  var variantId;
  if (previewVariantId !== undefined) {
    variantId = previewVariantId;
  } else if (rememberedVariant !== undefined) {
    variantId = rememberedVariant;
  } else {
    if (previouslySelectedVariant !== undefined) {
      var result = Belt_Array.getBy(experiment.targets, function (v) {
        return Caml_obj.equal(v.targetId, previouslySelectedVariant);
      });
      OptimizeLog$Showside.logWinner(experiment.id, "previous", previouslySelectedVariant);
      OptimizeLog$Showside.log2("previously selected variant", result);
      return result;
    }
    var result$1 = getVariant(experiment.targets, clientId, Belt_Option.getWithDefault(experiment.coverage, 100));
    if (result$1 !== undefined) {
      var partial_arg = experiment.id;
      Belt_Option.forEach(result$1.targetId, function (eta) {
        var param;
        OptimizeLog$Showside.logWinner(partial_arg, param, eta);
      });
      LocalStorage$Showside.set(undefined, {
        NAME: "optimizeVariant",
        VAL: experimentOrGroupId
      }, Belt_Option.getWithDefault(result$1.targetId, "baseline"));
    }
    return result$1;
  }
  var result$2 = Belt_Array.getBy(experiment.targets, function (v) {
    return Caml_obj.equal(v.targetId, variantId);
  });
  OptimizeLog$Showside.logWinner(experiment.id, "remembered", variantId);
  return result$2;
}
async function findMatchingPreview(experiments, facts) {
  var preview = getPreview(undefined);
  if (preview === undefined) {
    return;
  }
  var variantId = preview[1];
  var experimentId = preview[0];
  var previewExperiment = Belt_Array.getBy(experiments, function (experiment) {
    return experiment.id === experimentId;
  });
  var matchesEmbedType = previewExperiment !== undefined ? await matchPageTargeting(function (rule) {
    return {
      conditions: {
        all: Belt_Option.map(rule.conditions.all, function (__x) {
          return Belt_Array.keep(__x, function (rule) {
            return rule.fact === "Nav Type";
          });
        }),
        any: Belt_Option.map(rule.conditions.any, function (__x) {
          return Belt_Array.keep(__x, function (rule) {
            return rule.fact === "Nav Type";
          });
        })
      },
      event: rule.event
    };
  }, previewExperiment, facts) : false;
  if (matchesEmbedType && previewExperiment !== undefined) {
    OptimizeLog$Showside.log2("preview matched", {
      experiment: experimentId,
      variant: variantId
    });
    OptimizeLog$Showside.logWinner(experimentId, "preview", variantId);
    return [previewExperiment, variantId];
  }
}
async function get(redirectOpt, embedType, productTypeOpt, enhanceId, param) {
  var redirect = redirectOpt !== undefined ? redirectOpt : false;
  var productType = productTypeOpt !== undefined ? productTypeOpt : /* Nav */0;
  try {
    OptimizeLog$Showside.log(redirect ? "== redirect start ==" : "== start ==");
    var groups = OptimizeData$Showside.getGroups(redirect, productType, OptimizeLog$Showside.log, undefined);
    var experiments = OptimizeData$Showside.getExperiments(redirect, productType, OptimizeLog$Showside.log, undefined);
    var facts = await OptimizeFacts$Showside.getFacts(experiments, embedType, enhanceId, undefined);
    OptimizeLog$Showside.log2("facts", facts);
    var match;
    if (getIgnore(undefined)) {
      OptimizeLog$Showside.log("ignore optimize");
      match = [undefined, undefined];
    } else {
      var preview = await findMatchingPreview(experiments, facts);
      if (preview !== undefined) {
        match = [preview[0], preview[1]];
      } else {
        var selectedGroup = findMatchingGroup(groups);
        var experiments$1 = selectedGroup !== undefined ? Belt_Array.keep(experiments, function (experiment) {
          return Caml_obj.equal(experiment.groupId, Caml_option.some(selectedGroup.id));
        }) : Belt_Array.keep(experiments, function (experiment) {
          return Belt_Option.isNone(experiment.groupId);
        });
        var selectedExperiment = await findMatchingExperiment(experiments$1, facts);
        match = [selectedExperiment, undefined];
      }
    }
    var previewVariantId = match[1];
    var selectedExperiment$1 = match[0];
    var clientId = Belt_Option.map(selectedExperiment$1, function (experiment) {
      return getClientId(Belt_Option.mapWithDefault(experiment.groupId, experiment.id, Optimize$ApiTypes.Group.Id.toString));
    });
    var selectedVariant = selectedExperiment$1 !== undefined && clientId !== undefined ? await matchVariant(previewVariantId, clientId, selectedExperiment$1) : (OptimizeLog$Showside.log("no experiment matched"), undefined);
    var selectedVariant$1 = selectedVariant !== undefined ? await AltFunnel$Showside.updateAltFunnelVariant(selectedVariant) : undefined;
    var tmp;
    if (selectedExperiment$1 !== undefined) {
      if (selectedVariant$1 !== undefined) {
        var value = Belt_Option.mapWithDefault(selectedVariant$1.value, selectedVariant$1.targetId, function (v) {
          return v;
        });
        var value$1 = value === "" ? "baseline" : value;
        var measurementId = OptimizeData$Showside.getMeasurementId(undefined);
        var match$1 = selectedExperiment$1.groupId;
        var variantId = match$1 !== undefined ? Belt_Option.mapWithDefault(Belt_Array.getBy(Belt_Array.mapWithIndex(selectedExperiment$1.targets, function (index, target) {
          return [target.targetId, index === 0 ? "baseline" : "variant" + String(index) + ""];
        }), function (param) {
          return Caml_obj.equal(param[0], selectedVariant$1.targetId);
        }), "no variant targetId", function (param) {
          return param[1];
        }) : Belt_Option.getWithDefault(selectedVariant$1.targetId, "no variant targetId");
        OptimizeLog$Showside.log2("experiment matched", {
          group: selectedExperiment$1.groupId,
          groupVariant: variantId,
          experiment: selectedExperiment$1.id,
          experimentVariant: selectedVariant$1.targetId,
          value: value$1
        });
        fireEvent(undefined, measurementId, Belt_Option.mapWithDefault(selectedExperiment$1.groupId, selectedExperiment$1.id, Optimize$ApiTypes.Group.Id.toString), variantId, Belt_Option.getWithDefault(clientId, ""));
        var match$2 = selectedExperiment$1.experimentType;
        var match$3 = selectedExperiment$1.rememberVisitor;
        var match$4 = selectedVariant$1.targetId;
        if (match$2 !== 1 || !(match$3 && match$4 !== undefined && previewVariantId === undefined)) {} else {
          OptimizeLog$Showside.log("remember visitor");
          OptimizeFacts$Showside.rememberVisitor(selectedExperiment$1, selectedVariant$1);
        }
        tmp = value$1 === "baseline" ? undefined : value$1;
      } else {
        OptimizeLog$Showside.log("no variant matched");
        tmp = undefined;
      }
    } else {
      tmp = undefined;
    }
    return OptimizeLog$Showside.Tap.log2(tmp, redirect ? "== redirect end ==" : "== end ==");
  } catch (raw_exn) {
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    OptimizeLog$Showside.log2("error", exn);
    await reportToRollbar("Error raised in Optimize.get()", exn);
    return;
  }
}
function removeAntiFlickerClass(param) {
  document.documentElement.classList.remove("maker-anti-flicker");
}
function debuggerEnabled(param) {
  if (window.location.href.includes("maker_debugger=true")) {
    return true;
  } else {
    return Caml_obj.equal(Caml_option.null_to_opt(sessionStorage.getItem("smartnav__debugger_open")), "true");
  }
}
function trackRecentlyViewedProducts(accountId) {
  var productId = Belt_Option.map(ShopifyAnalytics$Showside.getProductPageProductId(undefined), function (productId) {
    return {
      TAG: /* ProductId */1,
      _0: productId
    };
  });
  if (productId === undefined) {
    return;
  }
  var currentValue = Belt_Option.getWithDefault(Belt_Option.map(LocalStorage$Showside.get(undefined, {
    NAME: "history",
    VAL: accountId
  }), UserSavedProductsTypes$Showside.Value.$$Array.fromString), []);
  var nextValue = Belt_Array.concat([productId], Belt_Array.keepWithIndex(Belt_Array.keep(currentValue, function (v) {
    return UserSavedProductsTypes$Showside.Value.toString(v) !== UserSavedProductsTypes$Showside.Value.toString(productId);
  }), function (p, i) {
    return i < 99;
  }));
  LocalStorage$Showside.set(undefined, {
    NAME: "history",
    VAL: accountId
  }, Curry._1(UserSavedProductsTypes$Showside.Value.$$Array.toString, nextValue));
}
function insertDebugger(param) {
  var script = document.getElementById("smartnav-debugger-script");
  if (!(script == null)) {
    return;
  }
  var localhost = Belt_Option.isSome(Caml_option.nullable_to_opt(document.querySelector("script[src^=\"http://localhost:8787/optimize.js?id=\"]")));
  var production = Belt_Option.isSome(Caml_option.nullable_to_opt(document.querySelector("script[src^=\"https://embed.maker.co/optimize.js?id=\"]")));
  var host = localhost ? "http://localhost:6007" : production ? "https://showside.maker.co" : window.location.origin;
  var script$1 = document.createElement("script");
  script$1.setAttribute("src", host + "/debugger.js");
  script$1.setAttribute("id", "smartnav-debugger-script");
  Belt_Option.forEach(Caml_option.nullable_to_opt(document.querySelector("head")), function (param) {
    param.appendChild(script$1);
  });
}
async function init(accountId) {
  OptimizeLog$Showside.log2("accountId", accountId);
  trackRecentlyViewedProducts(accountId);
  var previousEvents = getPreviousEvents(undefined);
  fireEventsAgain(undefined, previousEvents, OptimizeLog$Showside.log2);
  Belt_Array.forEach(previousEvents, function (previousEvent) {
    var previousExperimentId = Belt_Option.flatMap(Js_dict.get(previousEvent, "experiment_id"), Js_json.decodeString);
    var previousVariantId = Belt_Option.flatMap(Js_dict.get(previousEvent, "variant_id"), Js_json.decodeString);
    if (previousExperimentId !== undefined && previousVariantId !== undefined) {
      return OptimizeLog$Showside.logWinner(previousExperimentId, "previous", previousVariantId);
    }
  });
  if (debuggerEnabled(undefined)) {
    insertDebugger(undefined);
  }
  var match = AltFunnel$Showside.isAltFunnel(undefined);
  var match$1 = document.querySelector("#maker-smartnav, #maker-smartnav-inline, #maker-smartnav-pdp");
  if (match && match$1 == null) {
    AltFunnel$Showside.appendBottomBar(undefined);
  }
  var variant = await get(true, /* Inline */1, undefined, undefined, undefined);
  var url;
  if (variant !== undefined) {
    if (variant.startsWith("http")) {
      try {
        var newUrl = new URL(variant);
        new URL(window.location.href).searchParams.forEach(function (value, key) {
          if (key.startsWith("utm_") || Belt_Array.some(["gclid", "fbclid", "msclkid", "dclid", "ref", "aff_id", "affiliate_id", "aff", "s_cid", "s_cid", "campaign", "source", "medium"], function (k) {
            return k === key;
          })) {
            newUrl.searchParams.set(key, value);
            return;
          }
        });
        url = newUrl.toJSON();
      } catch (exn) {
        url = variant;
      }
    } else if (variant.startsWith("?")) {
      try {
        var newUrl$1 = new URL(window.location.href);
        new URL("" + window.location.origin + "" + variant + "").searchParams.forEach(function (value, key) {
          newUrl$1.searchParams.set(key, value);
        });
        url = newUrl$1.toJSON();
      } catch (exn$1) {
        url = variant;
      }
    } else {
      url = variant;
    }
  } else {
    url = variant;
  }
  if (url !== undefined) {
    if (url === window.location.href) {
      OptimizeLog$Showside.log2("redirect test - same url", url);
      return removeAntiFlickerClass(undefined);
    } else if (url.startsWith("http")) {
      OptimizeLog$Showside.log2("redirect test - redirect", url);
      window.location.href = url;
      return;
    } else {
      OptimizeLog$Showside.log2("redirect test - baseline", url);
      return removeAntiFlickerClass(undefined);
    }
  } else {
    return removeAntiFlickerClass(undefined);
  }
}
export { ourMeasurementId, getPreview, getIgnore, checkRawJs, getPreviousEvents, sendEventToGA, fireEvent, fireEventsAgain, getRememberedVariant, getNormalisedWeigth, floatFromClientId, getVariantIndex, getVariant, reportToRollbar, generateRandom32Bit, getClientId, findMatchingGroup, matchPageTargeting, isCustomJsRule, matchAudienceTargeting, validateCustomJsRules, matchCustomJs, removeRulesForRememberedVariant, isExperimentMatching, findMatchingExperiment, matchVariant, findMatchingPreview, get, removeAntiFlickerClass, debuggerEnabled, trackRecentlyViewedProducts, insertDebugger, init };
/* Rollbar Not a pure module */